// import React from 'react';
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function MainContent({ children }: { children: ReactNode }) {
  return (
    <main className="flex flex-1 h-0 min-h-0 overflow-hidden relative">
      {children}
    </main>
  );
}

export function ContentContainer({
  className,
  hidden,
  children,
}: {
  className?: string;
  hidden?: boolean;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "flex w-full h-full overflow-hidden",
        hidden && "hidden",
        className,
      )}
    >
      {children}
    </div>
  );
}

export function ContentMenu({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn("hidden md:block flex-none w-1/3 border-r", className)}>
      <div className="flex flex-col h-full">{children}</div>
    </div>
  );
}

export function ContentBody({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn("flex-1", className)}>
      <div className="flex flex-col h-full">{children}</div>
    </div>
  );
}
